import React from 'react';
import { observer } from 'mobx-react';
import Typography from '@material-ui/core/Typography';
import C3Chart from 'react-c3js';
import 'c3/c3.css';

import Panel from '../../commons/Panel';
import EvolucaoDialog from '../../commons/EvolucaoDialog';

import EvolucaoStore from '../../../stores/EvolucaoStore';
import SelecaoStore from '../../../stores/SelecaoStore';
import UIStore from '../../../stores/UIStore';

class Indecisos extends React.Component {
  componentWillMount() {
    UIStore.init('Índice de Indecisos', null, null, false);
  }

  render() {
    let participacao = SelecaoStore.participacao;
    let participacaoData = {
      type: 'pie',
      columns: [
        ['Candidatos', participacao.candidatos],
        ['Indecisos', participacao.indecisos],
        ['Brancos', participacao.brancos],
        ['Nulos', participacao.nulos],
        ['Não Votará', participacao.naoVotara],
      ],
    };
    return (
      <React.Fragment>
        <Panel
          title="Participação"
          loadHistory={() => EvolucaoStore.loadIndecisos()}
        >
          <Typography variant="subheading">
            Coeficiente Eleitoral: {participacao.coeficiente.formatInteger()}
          </Typography>
          <C3Chart
            style={{ height: '450px', maxHeight: '450px' }}
            data={participacaoData}
          />
        </Panel>
        <EvolucaoDialog
          title="Evolução da Participação"
          opened={EvolucaoStore.indecisos != null}
          columns={
            EvolucaoStore.indecisos ? EvolucaoStore.indecisos.columns : []
          }
          onOK={() => (EvolucaoStore.indecisos = null)}
        />
      </React.Fragment>
    );
  }
}

export default observer(Indecisos);



// WEBPACK FOOTER //
// ./src/components/proporcional/indecisos/index.js